// import buildQuery from 'common/helpers/buildQuery';
import axios from 'public/helpers/MyAxios';

const service = {
  fetchOne: token => axios.get(axios.addApiUrl(`/open/survey?token=${token}&expand=class,questionnaire.sections.items`)),
};

export default service;
